// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/pagination/upIcon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paginationPerPage {
  min-width: 159px;
  height: 40px;
  top: 117px;
  gap: 0px;
  border-radius: 10px;
  opacity: 1;
  background: #FFFFFF;
  border: 1.18px solid #0E2B63;
  padding: 10px;
  cursor: pointer;
  appearance: none;
  padding-right: 30px;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
}

.paginationPerPage,
option {
  font-family: Montserrat;
  font-size: 14.12px;
  font-weight: 400;
  line-height: 21.18px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  cursor: pointer;
}

.paginationBox {
  width: 40.68px;
  height: 40.68px;
  border-radius: 10.17px;
  margin: 1px 5px;
  cursor: pointer;
  text-align: center;
  border: 1.5px solid #f5f5f5;
  opacity: 1;
  font-weight: 600;
  font-family: 'Montserrat';
  font-size: 16px;
  transition: background-color 0.3s ease;

}

.paginationIcon {
  transition: transform 0.3s ease, filter 0.3s ease;
}

.paginationBox:hover {
  background-color: #112A63;
  color: white;
}

.paginationBox:hover .paginationIcon {
  filter: brightness(0) invert(1);
  transform: scale(1.1);
}

.paginationBox,
img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.paginationActive {
  font-weight: bold;
  background-color: #112A63;
  color: white;
}


.rows-per-page {
  margin-bottom: 10px;
}

.rows-per-page label {
  margin-right: 10px;
}

.pagination button {
  padding: 5px 10px;
  margin: 0 5px;
  cursor: pointer;
}

.pagination button.active {
  font-weight: bold;
  background-color: #007bff;
  color: white;
}

.pagination button:disabled {
  cursor: not-allowed;
  background-color: #f0f0f0;
}

.pagination input {
  padding: 5px;
  margin: 0 5px;
  width: 60px;
  text-align: center;
}
  @media screen and (max-width:800px) {
    .paginationContainer{
     overflow-y: scroll;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/pages/Import/Common/CustomPagination.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,eAAe;EAGf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,yDAAqD;EACrD,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;;AAExC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;EACE;IACE;KACC,kBAAkB;IACnB;EACF","sourcesContent":[".paginationPerPage {\n  min-width: 159px;\n  height: 40px;\n  top: 117px;\n  gap: 0px;\n  border-radius: 10px;\n  opacity: 1;\n  background: #FFFFFF;\n  border: 1.18px solid #0E2B63;\n  padding: 10px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  padding-right: 30px;\n  background-color: transparent;\n  background-image: url('assets/pagination/upIcon.svg');\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n}\n\n.paginationPerPage,\noption {\n  font-family: Montserrat;\n  font-size: 14.12px;\n  font-weight: 400;\n  line-height: 21.18px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  cursor: pointer;\n}\n\n.paginationBox {\n  width: 40.68px;\n  height: 40.68px;\n  border-radius: 10.17px;\n  margin: 1px 5px;\n  cursor: pointer;\n  text-align: center;\n  border: 1.5px solid #f5f5f5;\n  opacity: 1;\n  font-weight: 600;\n  font-family: 'Montserrat';\n  font-size: 16px;\n  transition: background-color 0.3s ease;\n\n}\n\n.paginationIcon {\n  transition: transform 0.3s ease, filter 0.3s ease;\n}\n\n.paginationBox:hover {\n  background-color: #112A63;\n  color: white;\n}\n\n.paginationBox:hover .paginationIcon {\n  filter: brightness(0) invert(1);\n  transform: scale(1.1);\n}\n\n.paginationBox,\nimg {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.paginationActive {\n  font-weight: bold;\n  background-color: #112A63;\n  color: white;\n}\n\n\n.rows-per-page {\n  margin-bottom: 10px;\n}\n\n.rows-per-page label {\n  margin-right: 10px;\n}\n\n.pagination button {\n  padding: 5px 10px;\n  margin: 0 5px;\n  cursor: pointer;\n}\n\n.pagination button.active {\n  font-weight: bold;\n  background-color: #007bff;\n  color: white;\n}\n\n.pagination button:disabled {\n  cursor: not-allowed;\n  background-color: #f0f0f0;\n}\n\n.pagination input {\n  padding: 5px;\n  margin: 0 5px;\n  width: 60px;\n  text-align: center;\n}\n  @media screen and (max-width:800px) {\n    .paginationContainer{\n     overflow-y: scroll;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
